import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 900;
  padding-bottom: ${({ theme }) => theme.landingSpacing.md};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding-bottom: ${({ theme }) => theme.landingSpacing.sm};
  }

  /* position: absolute;
  bottom: 0;
  left: 100%; */
`;

export const PoweredByButton = styled.button`
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.xs};
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  /* background: transparent;
  border: none; */
  padding: ${({ theme }) => theme.landingSpacing.xs} ${({ theme }) => theme.landingSpacing.md};
  cursor: pointer;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.97);
  }
`;

export const PoweredByText = styled.span`
  font-weight: 500;
  font-size: 0.8rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.textSecondary};
  white-space: nowrap;
`;

export const FooterLogo = styled.img`
  height: 17px;
  width: auto;
  object-fit: contain;
  align-self: baseline;
`;
